import React from 'react'
import PropTypes from 'prop-types'

function VerticalList ({ children, className, border }) {
  const classNames = [
    'vertical-list',
    border ? 'group divide-y divide-gray-200' : ''
  ]

  return (
    <div className={className}>
      <div className={classNames.join(' ')}>
        {children}
      </div>
    </div>
  )
}

VerticalList.defaultProps = {
  className: '',
  border: true
}

VerticalList.propTypes = {
  /**
     * Add a custom className to the grid's wrapper
     */
  className: PropTypes.string,
  /**
     * Add a border to the child elements?
     * Default: true
     */
  border: PropTypes.bool
}

export default VerticalList
